<template>
  <div>
    <ViewTemplateWithTable :panel="panel" :templateList="templateList" :actions="actions" :filters="filters"
      :propsParam="propsParam">
      <div slot="content-buttons">
        <Button _key="btnSupplierOrderCreate" title="Pedido de Fornec..." classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
      <div slot="content-between-search-table">
        <div class="div-archived">
          <ButtonToggle titleActive="Arquivada" titleInactive="Arquivada" colorActive="#453DB4"
            classIconActive="fa-regular fa-check-double" classIconInactive="fa-solid fa-box-archive"
            colorInactive="#F0F0F0" v-model="propsParam.archived" />
        </div>
      </div>
    </ViewTemplateWithTable>
  </div>
</template>

<script>

import ViewTemplateWithTable from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithTable.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import ButtonToggle from "@nixweb/nixloc-ui/src/component/forms/ButtonToggle";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SupplierOrderListView",
  components: {
    ViewTemplateWithTable,
    ButtonToggle,
    Button,
  },
  data() {
    return {
      id: "",
      panel: {
        module: "Fornecedor",
        title: "Pedido de Fornecedor",
        showFilter: true,
        showSearch: true,
        showButtons: true,
      },
      templateList: {
        urlGetApi: "/api/v1/supplier/supplier-order/get-all",
        urlDeleteAllApi: "/api/v1/supplier/supplier-order/delete",
        showChecks: true,
        headerTable: [
          {
            title: "",
            field: "archivedHtml",
            type: "html",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            styleBody: "width: 20px;",
          },
          {
            title: "Número/Data",
            field: "numberAndDate",
            type: "text",
            iconSearch: true,
            styleBody: "width: 140px;",
          },
          {
            field: "fullName",
            fieldSecond: "identification",
            title: "Fornecedor",
            type: "link",
            routeName: "supplierOrderUpdate",
            styleBody: "max-width: 300px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;",
            iconSearch: true,
          },
          {
            field: "consultant",
            title: "Solicitado por",
            type: "text",
            styleBody: "max-width: 150px;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;",
            classCssTitle: "text-center",
            classCssBody: "text-center",
          },
          /*  {
              title: "Período(Início/Fim)",
              field: "tags",
              type: "html",
              classCssTitle: "text-center",
              classCssBody: "text-center",
              styleBody: "max-width: 300px;",
            },*/
          {
            field: "status",
            title: "Status",
            type: "class",
            fieldComparison: "status",
            classCssTitle: "text-center",
            classCssBody: [
              {
                classCss: "text-center badge badge-info",
                fieldComparison: "Orçamento",
              },
              {
                classCss: "text-center badge badge-success",
                fieldComparison: "Aprovada",
              },
              {
                classCss: "text-center badge badge-danger",
                fieldComparison: "Reprovada",
              },
            ],
          },
          {
            title: "Valor",
            field: "total",
            classCssTitle: "text-center",
            classCssBody: "text-center",
            type: "currency",
          },
        ],
      },
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: "/api/v1/supplier/supplier-order/delete", method: "delete", },
      ],
      filters: [
        {
          type: "multiOptions",
          title: "Consultor",
          field: "Consultant",
          url: "/api/v1/human-resources/collaborator/select-all",
          propsParams: { isConsultant: true },
          value: "",
        },
        {
          type: "date",
          title: "Data Cadastro",
          field: "RegisteredDate",
          value: "",
        },
        {
          type: "date",
          title: "Data Efetivação",
          field: "DateAccepted",
          value: "",
        },
        {
          type: "options",
          title: "Faturamento",
          field: "StatusInvoiceName",
          options: [
            { text: "Faturado", value: "Faturado" },
            { text: "Parcial", value: "Parcial" },
            { text: "Não Faturado", value: "Não Faturado" },
            { text: "Não Fatura", value: "Não Fatura" },
          ],
          value: [],
        },
        {
          type: "dateRange",
          title: "Período de Locação",
          field: "PeriodRent",
          value: "",
        },
        {
          type: "options",
          title: "Status",
          field: "StatusRentalName",
          options: [
            { text: "Orçamento", value: "Orçamento" },
            { text: "Aprovada", value: "Aprovada" },
            { text: "Reprovada", value: "Reprovada" },
          ],
          value: [],
        },
        {
          type: "decimal",
          title: "Valor",
          field: "TotalGeneral",
          valueStart: 0,
          valueEnd: 0,
        },
      ],
      propsParam: {
        archived: false,
      },
    };
  },
  mounted() {
    var filterStorage = this.get_FilterStorage(this.$route.name);
    if (filterStorage) {
      this.propsParam = filterStorage.propsParam;
    }
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event", "get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["openModal", "hideModal", "removeLoading", "executedSearch", "_addFilterStorage"]),
    create() {
      let self = this;
      setTimeout(function () {
        self.$router.push({
          name: "supplierOrderCreate",
        });
        self.removeLoading(["btnSupplierOrderCreate"]);
      }, 200);
    },
  },
  watch: {
    propsParam: {
      handler() {
        this.executedSearch();
        this._addFilterStorage({ routeName: this.$route.name, propsParam: this.propsParam });
      },
      deep: true,
    },
  },
};
</script>

<style>
.badge-default {
  background-color: #eeeeee;
  font-size: 13px !important;
  border-radius: 50px !important;
}

.div-archived {
  margin-bottom: 10px;
  margin-left: 5px;
  width: 125px;
}

.div-status {
  margin-left: 35px;
}

.rent-progress {
  color: #4bb4e2;
}

.rent-accepted {
  color: #38A169;
}

.rent-rejected {
  color: #FF5454;
}

.rent-icon-close {
  color: red;
}
</style>